import SSL_PARAMETERS from '@/app/modules/terminals/enums/SslParameters';
import SUBSCRIPTION_STATUS from '../enums/SubscriptionStatus';
import NETWORK_INTERFACE_TYPE from '../../terminals/enums/NetworkInterfaceType';
import POS_TERMINAL_STATUS from '../../terminals/enums/PosTerminalStatus';
import { nsSubscription, nsTerminal } from '@/app/i18n/namespaces';
import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';
import { FILTER_TYPES } from '@/common-utils/components/renders/dataTable/filter/FilterTypes';
import SIM_CARDS_STATUS from '../../sims/enums/SimCardStatus';

export default {
    MORE_INFO: {
        entity: 'posTerminals_column_type_details'
    },
    UUID: {
        key: 'uuid',
        enableSorting: false
    },
    DETAILS: {
        key: 'details'
    },
    CLIENT: {
        key: 'client',
        UUID: {
            parentKeys: ['client'],
            key: 'uuid'
        },
        LEGAL_NAME: {
            parentKeys: ['client'],
            key: 'legalName',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.client.legal_name',
            namespace: nsSubscription,
            placeholder: 'filter.placeholder.client.legal_name',
            filter: FILTER_TYPES.INPUT,
            enableSorting: true,
            isNested: true
        },
        CLIENT_CODE: {
            parentKeys: ['client'],
            key: 'clientCode',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.client.code',
            namespace: nsSubscription,
            placeholder: 'filter.placeholder.client.code',
            filter: FILTER_TYPES.INPUT,
            enableSorting: true,
            isNested: true
        }
    },
    MERCHANT_ORGANIZATION: {
        key: 'merchantOrganization',
        type: FIELD_TYPES.TEXT,
        entity: 'subscription_merchant_organization'
    },
    START_BILLING_DATE: {
        key: 'startBillingDate',
        type: FIELD_TYPES.DATE_NO_TIME,
        entity: 'keys.start_billing_date',
        namespace: nsSubscription,
        filter: FILTER_TYPES.DATE,
        enableSorting: true
    },
    ACTIVATION_DATE: {
        key: 'activationDate',
        type: FIELD_TYPES.DATE,
        entity: 'keys.activation_date',
        namespace: nsSubscription,
        filter: FILTER_TYPES.DATE,
        enableSorting: true
    },
    RESILIATION_DATE: {
        key: 'resiliationDate',
        type: FIELD_TYPES.DATE,
        entity: 'keys.resiliation_date',
        namespace: nsSubscription,
        filter: FILTER_TYPES.DATE,
        enableSorting: true
    },
    PAYLUDD_TERMINATION_DATE: {
        key: 'payluddTerminationDate',
        type: FIELD_TYPES.DATE,
        entity: 'keys.payludd_termination_date',
        namespace: nsSubscription
    },
    LAST_PAYLUDD_CONNECTION_DATE: {
        key: 'lastPayluddConnectionDate',
        type: FIELD_TYPES.DATE,
        entity: 'keys.last_payludd_connection_date',
        namespace: nsSubscription
    },
    SUBSCRIPTION_PLAN: {
        key: 'subscriptionPlan',
        LABEL: {
            parentKeys: ['subscriptionPlan'],
            key: 'label',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.plan_label',
            namespace: nsSubscription,
            placeholder: 'filter.placeholder.plan_label',
            filter: FILTER_TYPES.INPUT,
            enableSorting: true,
            isNested: true
        },
        PRODUCT_CODE: {
            parentKeys: ['subscriptionPlan'],
            key: 'productCode',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.product_code',
            namespace: nsSubscription,
            placeholder: 'filter.placeholder.product_code',
            filter: FILTER_TYPES.INPUT,
            enableSorting: true,
            isNested: true
        }
    },
    SUBSCRIPTIONS: {
        key: 'subscriptions'
    },
    LAST_CONNECTION_TYPE: {
        key: 'lastConnectionType',
        type: 'select',
        entity: 'keys.network_interface_type',
        tooltip: 'tooltip.subscriptions.last_connection_type',
        namespace: nsTerminal,
        filter: FILTER_TYPES.SELECT,
        enum: NETWORK_INTERFACE_TYPE,
        enableSorting: true
    },
    LAST_ICCID: {
        key: 'lastIccid',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.sim_card_number',
        namespace: nsSubscription
    },
    ACTIVE_ICCID: {
        key: 'activeIccid',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.sim_card_number',
        namespace: nsSubscription,
        placeholder: 'filter.placeholder.sim_card_number',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    LAST_SOURCE_IP: {
        key: 'lastSourceIp',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.last_source_ip',
        namespace: nsSubscription,
        placeholder: 'filter.placeholder.last_source_ip',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    LAST_GEOLOCALISATION: {
        key: 'lastGeolocalisationIp',
        type: FIELD_TYPES.TEXT,
        enableSorting: false
    },
    LAST_SSL_VERSION: {
        key: 'lastSslVersion',
        type: 'select',
        entity: 'keys.last_ssl_version',
        namespace: nsSubscription,
        filter: FILTER_TYPES.SELECT,
        enum: SSL_PARAMETERS,
        enableSorting: true
    },
    POS_TERMINAL: {
        key: 'posTerminal',
        UUID: {
            parentKeys: ['posTerminal'],
            key: 'uuid'
        },
        IS_BROADCAST: {
            parentKeys: ['posTerminal'],
            key: 'isBroadcast',
            type: FIELD_TYPES.BOOLEAN,
            isNested: true
        },
        SIM: {
            key: 'sim',
            parentKeys: ['posTerminal'],
            SIM_OFFER: {
                key: 'simOffer',
                parentKeys: ['posTerminal', 'sim'],
                SHORT_DISPLAY_NAME: {
                    key: 'shortDisplayName',
                    parentKeys: ['posTerminal', 'sim', 'simOffer'],
                    type: FIELD_TYPES.TEXT,
                    entity: 'keys.sim.offer',
                    namespace: nsTerminal
                }
            },
            SIM_ACTIVATED_ON: {
                parentKeys: ['posTerminal', 'sim'],
                key: 'activatedOn',
                type: FIELD_TYPES.DATE,
                entity: 'keys.sim.activated_on',
                namespace: nsTerminal,
                filter: FILTER_TYPES.DATE,
                isNested: true
            },
            SIM_STATUS: {
                parentKeys: ['posTerminal', 'sim'],
                key: 'status',
                type: FIELD_TYPES.BADGE,
                entity: 'keys.sim.status',
                namespace: nsTerminal,
                filter: FILTER_TYPES.SELECT,
                enum: SIM_CARDS_STATUS,
                isNested: true
            }
        },
        SERIAL_NUMBER: {
            parentKeys: ['posTerminal'],
            key: 'serialNumber',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.serial_number',
            namespace: nsTerminal,
            filter: FILTER_TYPES.INPUT,
            placeholder: 'filter.placeholder.serial_number',
            enableSorting: true,
            isNested: true
        },
        MANUFACTURER: {
            parentKeys: ['posTerminal'],
            key: 'manufacturer',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.manufacturer',
            namespace: nsTerminal,
            filter: FILTER_TYPES.INPUT,
            placeholder: 'filter.placeholder.manufacturer',
            enableSorting: true,
            isNested: true
        },
        LABEL: {
            parentKeys: ['posTerminal'],
            key: 'label',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.label',
            namespace: nsTerminal,
            filter: FILTER_TYPES.INPUT,
            placeholder: 'filter.placeholder.label',
            enableSorting: true,
            isNested: true
        },
        CUSTOM_LABEL: {
            parentKeys: ['posTerminal'],
            key: 'customLabel',
            type: FIELD_TYPES.TEXT,
            entity: 'keys.custom_label',
            namespace: nsTerminal,
            filter: FILTER_TYPES.INPUT,
            placeholder: 'filter.placeholder.custom_label',
            enableSorting: true,
            isNested: true
        },
        CREATED_AT: {
            parentKeys: ['posTerminal'],
            key: 'createdAt',
            type: FIELD_TYPES.DATE,
            entity: 'keys.created_at',
            namespace: nsTerminal,
            filter: FILTER_TYPES.DATE,
            enableSorting: true
        },
        UPDATED_AT: {
            parentKeys: ['posTerminal'],
            key: 'updatedAt',
            type: FIELD_TYPES.DATE,
            entity: 'keys.updated_at',
            namespace: nsTerminal,
            filter: FILTER_TYPES.DATE,
            enableSorting: true
        },
        LAST_CONNECTION_GPRS: {
            parentKeys: ['posTerminal'],
            key: 'lastGprsCall',
            type: FIELD_TYPES.DATE,
            entity: 'keys.last_gprs_call',
            namespace: nsTerminal,
            isNested: true
        },
        LAST_CONNECTION_IP: {
            parentKeys: ['posTerminal'],
            key: 'lastIpCall',
            type: FIELD_TYPES.DATE,
            entity: 'keys.last_connection_ip',
            namespace: nsTerminal,
            isNested: true
        },
        STATUS: {
            parentKeys: ['posTerminal'],
            key: 'status',
            type: FIELD_TYPES.BADGE,
            entity: 'keys.status',
            namespace: nsTerminal,
            filter: FILTER_TYPES.SELECT,
            enum: POS_TERMINAL_STATUS,
            enableSorting: true,
            isNested: true
        },
        BLACKLIST_START_DATE: {
            parentKeys: ['posTerminal'],
            key: 'blacklistStartDate',
            restApiAddBlacklistKey: 'startDate',
            type: FIELD_TYPES.DATE,
            entity: 'keys.start_blacklist',
            namespace: nsSubscription,
            filter: FILTER_TYPES.DATE,
            enableSorting: true,
            isNested: true
        },
        REWAREHOUSE_DATE: {
            parentKeys: ['posTerminal'],
            key: 'rewarehousedAt',
            type: FIELD_TYPES.DATE,
            entity: 'keys.rewarehouse_at',
            namespace: nsTerminal,
            filter: FILTER_TYPES.DATE,
            enableSorting: true,
            isNested: true
        },
        DIRECT_PROVIDER: {
            parentKeys: ['posTerminal'],
            key: 'directProvider',
            PROVIDER_LEGAL_NAME: {
                parentKeys: ['posTerminal', 'directProvider'],
                key: 'legalName',
                type: FIELD_TYPES.TEXT,
                entity: 'keys.provider_legal_name',
                namespace: nsTerminal,
                placeholder: 'filter.placeholder.provider_legal_name',
                filter: FILTER_TYPES.INPUT,
                enableSorting: true,
                isNested: true
            },
            PROVIDER_UUID: {
                parentKeys: ['posTerminal', 'directProvider'],
                key: 'uuid'
            }
        },
        HAS_MIGRATED: {
            parentKeys: ['posTerminal'],
            key: 'hasMigrated',
            type: FIELD_TYPES.TEXT,
            entity: 'subscription_posTerminal_has_migrated'
        },
        PAYLUDD: {
            parentKeys: ['posTerminal'],
            key: 'payludd',
            isNested: true
        }
    },
    STATUS: {
        key: 'status',
        type: FIELD_TYPES.BADGE,
        prefix: 'subscriptionStatus_',
        entity: 'keys.status',
        namespace: nsSubscription,
        filter: FILTER_TYPES.SELECT,
        enum: SUBSCRIPTION_STATUS,
        enableSorting: true
    },
    PROVIDER: {
        key: 'provider'
    },
    DIRECT_PROVIDER: {
        key: 'directProvider'
    },
    CREATED_AT: {
        key: 'createdAt',
        type: FIELD_TYPES.DATE,
        entity: 'keys.created_at',
        namespace: nsSubscription,
        filter: FILTER_TYPES.DATE,
        enableSorting: true
    },
    UPDATED_AT: {
        key: 'updatedAt',
        type: FIELD_TYPES.DATE,
        entity: 'keys.updated_at',
        namespace: nsSubscription,
        filter: FILTER_TYPES.DATE,
        enableSorting: true
    },
    LAST_CONNECTION_DATE: {
        key: 'lastConnectionDate',
        type: FIELD_TYPES.DATE,
        entity: 'keys.last_connection',
        namespace: nsSubscription,
        filter: FILTER_TYPES.DATE,
        enableSorting: true
    },
    OPERATOR: {
        key: 'lastIccid',
        type: FIELD_TYPES.TEXT,
        entity: 'merchantContract_operator'
    },
    LAST_ICCID_OPERATOR: {
        key: 'lastIccidOperator',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.last_iccid_operator',
        namespace: nsSubscription
    },
    ACTIVE_ICCID_OPERATOR: {
        key: 'activeIccidOperator',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.active_iccid_operator',
        namespace: nsSubscription
    },
    IS_MIGRATING: {
        key: 'isInMigration',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.is_in_migration'
    }
};